/**
 * =============================================================================
 * IDS CRM - Notes which list each page was opened from
 * =============================================================================
 *
 * Sits once at the top of the app, above the pages. Every time the app moves
 * to another page it records where that page was opened from (see
 * utils/listReturn.js trackNavigation), so the page's "←" link can go back
 * to that list as it was left.
 *
 * The note is made while rendering, before the page below draws its "←"
 * link in the same pass. It only writes the same small value to the tab's
 * storage, so drawing twice does no harm.
 * =============================================================================
 */

import { useEffect, useRef } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';
import { trackNavigation } from '../utils/listReturn';

function ListOriginTracker() {
  const location = useLocation();
  const navigationType = useNavigationType();
  // The page the app was showing before this move.
  const shown = useRef(null);

  if (shown.current !== location.pathname) {
    trackNavigation(shown.current, location.pathname, navigationType);
  }

  useEffect(() => {
    shown.current = location.pathname;
  }, [location.pathname]);

  return null;
}

export default ListOriginTracker;
